/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, number as codecNumber, oneOf as codecOneOf, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Assignment } from './Assignment';
import { AssignmentAnonymizationAlgo } from './AssignmentAnonymizationAlgo';
import { AssignmentPeerFeedbackSettings } from './AssignmentPeerFeedbackSettings';
import { AssignmentPercentageGradingSettings } from './AssignmentPercentageGradingSettings';
import { AssignmentPointsGradingSettings } from './AssignmentPointsGradingSettings';
import { AssignmentSubmissionMode } from './AssignmentSubmissionMode';
import { CGIgnoreVersion } from './CGIgnoreVersion';
import { GroupSet } from './GroupSet';
import { SubmissionValidatorInputData } from './SubmissionValidatorInputData';
import { WebhookConfigurationDisabledAsJSON } from './WebhookConfigurationDisabledAsJSON';
import { WebhookConfigurationEnabledAsJSON } from './WebhookConfigurationEnabledAsJSON';
const ExtendedAssignmentParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    [
        'cgignore',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([SubmissionValidatorInputData, codecString])),
    ],
    [
        'cgignoreVersion',
        /* #__PURE__ */ parsers.maybeNull(CGIgnoreVersion),
        'cgignore_version',
    ],
    ['sendLoginLinks', codecBoolean, 'send_login_links'],
    [
        'fixedMaxRubricPoints',
        /* #__PURE__ */ parsers.maybeNull(codecNumber),
        'fixed_max_rubric_points',
    ],
    ['maxGrade', codecNumber, 'max_grade'],
    [
        'grading',
        /* #__PURE__ */ parsers.taggedUnion('scale', [
            ['percentage', AssignmentPercentageGradingSettings],
            ['points', AssignmentPointsGradingSettings],
        ]),
    ],
    ['groupSet', /* #__PURE__ */ parsers.maybeNull(GroupSet), 'group_set'],
    [
        'autoTestId',
        /* #__PURE__ */ parsers.maybeNull(codecNumber),
        'auto_test_id',
    ],
    ['filesUploadEnabled', codecBoolean, 'files_upload_enabled'],
    [
        'webhookConfiguration',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', WebhookConfigurationEnabledAsJSON],
            ['disabled', WebhookConfigurationDisabledAsJSON],
        ]),
        'webhook_configuration',
    ],
    ['editorUploadEnabled', codecBoolean, 'editor_upload_enabled'],
    [
        'maxSubmissions',
        /* #__PURE__ */ parsers.maybeNull(codecNumber),
        'max_submissions',
    ],
    ['coolOffPeriod', parsers.duration, 'cool_off_period'],
    ['amountInCoolOffPeriod', codecNumber, 'amount_in_cool_off_period'],
    [
        'reminderTime',
        /* #__PURE__ */ parsers.maybeNull(parsers.moment),
        'reminder_time',
    ],
    ['lmsName', /* #__PURE__ */ parsers.maybeNull(codecString), 'lms_name'],
    [
        'peerFeedbackSettings',
        /* #__PURE__ */ parsers.maybeNull(AssignmentPeerFeedbackSettings),
        'peer_feedback_settings',
    ],
    ['doneType', /* #__PURE__ */ parsers.maybeNull(codecString), 'done_type'],
    [
        'doneEmail',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'done_email',
    ],
    [
        'divisionParentId',
        /* #__PURE__ */ parsers.maybeNull(codecNumber),
        'division_parent_id',
    ],
    [
        'anonymizedGrading',
        /* #__PURE__ */ parsers.maybeNull(AssignmentAnonymizationAlgo),
        'anonymized_grading',
    ],
    [
        'fileToLoadFirst',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'file_to_load_first',
    ],
    ['submissionMode', AssignmentSubmissionMode, 'submission_mode'],
])), Assignment);
export class ExtendedAssignment extends Assignment {
    static decode(input) {
        return ExtendedAssignmentParser.decode(input).map(res => new ExtendedAssignment(res));
    }
    static unsafeDecode(input) {
        return ExtendedAssignment.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedAssignmentParser.encode(data);
    }
    static schema() {
        return ExtendedAssignmentParser.schema();
    }
}
